import {
  SET_WAREHOUSES_GRAPHS_FILTERS,
  CLEAR_WAREHOUSES_GRAPHS
} from "redux/reducers/warehousesGraphs/warehousesGraphsReducer";

export const setWarehousesGraphsFilters = (key = "", data) => ({
  type: SET_WAREHOUSES_GRAPHS_FILTERS,
  payload: { key, data }
});

export const clearWarehousesGraphs = () => ({
  type: CLEAR_WAREHOUSES_GRAPHS
});
